export const DEFAULT_IMAGE_WIDTH = 2000;
